import { NotificationTopic } from '@web/components/Notifications/NotificationHandlerService';
import { useLatestNotification } from '@web/components/Notifications/hooks/useLatestNotification';
import { config } from '@web/config/env';
import {
  saveTimesheetRequestAsync,
  saveTimesheetRequestAsyncFailure,
  saveTimesheetRequestAsyncSuccess,
} from '@web/redux/Timesheet/actions';
import { useAppDispatch } from '@web/redux/store';
import { sendPrintToIntacct } from '@web/services/intacct';
import { useEffect, useState } from 'react';

export function useSendPrintToIntacct() {
  const dispatch = useAppDispatch();
  const [timesheetId, setTimesheetId] = useState<string | null>(null);
  const [recordNo, setRecordNo] = useState<string | null>(null);
  const { notification: syncResponse } = useLatestNotification(NotificationTopic.SAVE_TIMESHEET);
  const [syncingToIntacct, setSyncingToIntacct] = useState(false);

  useEffect(() => {
    if (!syncingToIntacct || !syncResponse || recordNo == null || timesheetId == null) return;
    const { type, data } = syncResponse;
    // We have to do this instead of the `useLatestNotification` params hook.
    if (!('timesheetId' in data && data.timesheetId === timesheetId)) return;
    if (type === 'SUCCESS') {
      dispatch(saveTimesheetRequestAsyncSuccess({ id: timesheetId }));
      setTimesheetId(null);
      setRecordNo(null);
      sendPrintToIntacct(recordNo, config.VITE_APP_INTACCT_ORIGIN);
    } else {
      dispatch(saveTimesheetRequestAsyncFailure({ id: timesheetId }));
    }
    setSyncingToIntacct(false);
  }, [dispatch, recordNo, syncResponse, syncingToIntacct, timesheetId]);

  return ({ recordNo, timesheetId }: { recordNo: string; timesheetId: string }) => {
    dispatch(saveTimesheetRequestAsync({ id: timesheetId }));
    setSyncingToIntacct(true);
    setRecordNo(recordNo);
    setTimesheetId(timesheetId);
  };
}
